import { formatReward } from "./instant-data";
import PrimaryButton from "./primary-button";

export default function Landing({ amount, onNext, onChat }) {
  const reward = formatReward(amount, { trailingPeriod: true });
  const rewardText = formatReward(amount) || "reward";
  return (
    <section className="ir-landing">
      <h1 className="ir-display">
        <span>YOU EARNED</span>
        {reward ? <span className="ir-display-accent">{reward}</span> : null}
      </h1>
      <p className="ir-landing-sub">Join 600,000 members saving for what they love.</p>
      <PrimaryButton onClick={onNext}>Next</PrimaryButton>
      <p className="ir-landing-note">Takes about 3 minutes</p>
      <p className="ir-landing-check">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M3 3.5h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H7.5L5 14v-2.5H3a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
        </svg>
        <span>
          Rather get a check instead?{" "}
          <button type="button" className="ir-landing-check-link" onClick={onChat}>
            Tap Chat
          </button>{" "}
          and Support will mail your {rewardText}.
        </span>
      </p>
    </section>
  );
}
